import './testimonial-list.scss';

import Swiper from 'swiper';
import { Navigation, A11y, Pagination } from 'swiper/modules';

class TestimonialList {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-testimoniallist',
            sliderAttr: 'slider',
            slideAttr: 'slide',
            controlsAttr: 'controls'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.slider = null;

        // Elements
        this.$testimonialList = element;
        this.$testimonialListSlider = this.$testimonialList.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$testimonialListControls = this.$testimonialList.querySelector(`[${this.settings.initAttr}="${this.settings.controlsAttr}"]`);
    }

    initialize () {
        if (this.$testimonialListSlider && this.$testimonialListControls) {
            this.initSlider();
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$testimonialListSlider, {
            modules: [Navigation, Pagination, A11y],
            speed: 500,
            effect: 'fade',
            slidesPerView: 1,
            centeredSlides: true,
            autoHeight: true,
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                paginationBulletMessage: 'Springe zu Slide {{index}}',
                firstSlideMessage: 'Dies ist der Erste Slide',
                lastSlideMessage: 'Dies ist der Letzte Slide',
                slideLabelMessage: 'Slide {{index}} von {{slidesLength}}'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
            }
        });
    }

    setEvents () {}
}

export { TestimonialList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$testimonialList = $context.querySelectorAll('[data-testimoniallist="root"]');
        for (let i = 0; i < $$testimonialList.length; i++) {
            const $testimonialList = $$testimonialList[i];

            const $testimonialListAPI = new TestimonialList($testimonialList);
            $testimonialListAPI.initialize();
        }
    }
});
